import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import classnames from "classnames";
import Modal from "@components/ui-components/modal";

const QUICK_REASONS = ["Wrong amount", "Incorrect UTR / reference", "Paid to wrong beneficiary", "Brand requested a change"];

const RevertDebitNoteModal = ({ open, onClose, debitNoteLabel, onRevert }) => {
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (open) setReason("");
    }, [open]);

    const handleRevert = async () => {
        setSubmitting(true);
        try {
            await onRevert(reason);
            onClose();
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Revert debit note"
            subtitle={`${debitNoteLabel} will be marked reverted. Available while the note is issued or acknowledged, before the brand approves it.`}
            footer={(
                <>
                    <button
                        type="button"
                        onClick={onClose}
                        className="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50">
                        Cancel
                    </button>
                    <button
                        type="button"
                        disabled={!reason.trim() || submitting}
                        onClick={handleRevert}
                        className="rounded-lg bg-danger px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-danger/90 disabled:cursor-not-allowed disabled:opacity-50">
                        Revert debit note
                    </button>
                </>
            )}>
            <div>
                <label className="mb-1.5 block text-sm font-medium text-gray-700">Reason for reversal</label>
                <textarea
                    rows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Explain why this step is being reverted — it is written to the audit log."
                    className="w-full resize-none rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20" />

                <div className="mt-3 flex flex-wrap gap-2">
                    {QUICK_REASONS.map((quick) => (
                        <button
                            key={quick}
                            type="button"
                            onClick={() => setReason(quick)}
                            className={classnames(
                                "rounded-full border px-3 py-1.5 text-xs font-medium transition-colors",
                                reason === quick
                                    ? "border-primary bg-primary/5 text-primary"
                                    : "border-gray-300 text-gray-600 hover:bg-gray-50"
                            )}>
                            {quick}
                        </button>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

RevertDebitNoteModal.propTypes = {
    open          : PropTypes.bool.isRequired,
    onClose       : PropTypes.func.isRequired,
    debitNoteLabel: PropTypes.string.isRequired,
    onRevert      : PropTypes.func.isRequired
};

export default RevertDebitNoteModal;
